import {Component, OnInit, OnChanges, Input, ViewChildren, QueryList} from '@angular/core';
import {MatMenuTrigger} from '@angular/material';
import {UtilsService} from '../../core/utils/utils.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})

export class SidenavComponent implements OnInit, OnChanges {
  menuOpened = false;
  menuIcons = '../../assets/images/menu-icons/';
  styleOpenedSidenav = {width: '40px'};
  menuTimer;
  @Input() modulos: any[] = [
    {nome: 'teste', caption: 'Nível 1', icon: 'analisar.svg'},
    {
      nome: 'teste_submenu', caption: 'Nivel 1', icon: 'analisar.svg',
      submenus: [
        {nome: 'teste_submenu', caption: 'Submenu 2'},
        {
          nome: 'teste_submenu', caption: 'Submenu Nivel 2',
          submenus: [{nome: 'teste_submenu', caption: 'Submenu Nivel 3'}]
        }]
    },
    {nome: 'teste', caption: 'Nível 1', icon: 'analisar.svg'},
    {
      nome: 'teste_submenu', caption: 'Nivel 1', icon: 'analisar.svg',
      submenus: [
        {
          nome: 'teste_submenu', caption: 'Submenu Nivel 2',
          submenus: [{nome: 'teste_submenu', caption: 'Submenu Nivel 3'}]
        },
        {nome: 'teste_submenu', caption: 'Submenu 2'}
      ]
    }
  ];
  @Input() videoUrl;
  @Input() showConfig;

  @ViewChildren('menuTrigger') menuTrigger: QueryList<MatMenuTrigger>;

  usuarioPapel;
  modulosFiltered = [];

  constructor(private _utils: UtilsService) {
  }

  mouseOnSidenav($event) {
    const component = this;
    this.menuOpened = true;
    this.menuTimer = setTimeout(function () {
      component.styleOpenedSidenav = {
        width: '200px'
      };
    }, 0);
  }

  mouseLeaveSidenav($event) {
    if ($event.relatedTarget.classList[0] !== 'mat-menu-item' &&
      $event.relatedTarget.classList[0] !== 'mat-nav-list' &&
      $event.relatedTarget.classList[0] !== 'mat-list-item-content') {
      clearTimeout(this.menuTimer);
      this.styleOpenedSidenav = {
        width: '40px'
      };
    }
  }

  openMenu(i) {
    this.menuTrigger['_results'][i].openMenu();
  }

  closeMenu($event, i) {
    if ($event.relatedTarget.classList[0] !== 'mat-menu-item') {
      this.menuTrigger['_results'][i].closeMenu();
      this.mouseLeaveSidenav($event);
    }
  }

  submenuClose($event, i) {
    if ($event.relatedTarget.classList[0] !== 'mat-menu-item') {
      this.menuTrigger['_results'][i].closeMenu();
      this.mouseLeaveSidenav($event);
    }
  }

  filterModulos(modulos, usuarioPapel) {
    return modulos.filter((modulo) => {
      if (modulo.showMenu && modulo['papeis'] && modulo['papeis'].indexOf(usuarioPapel) > -1) {
        if (modulo.children) {
          return modulo.children = this.filterModulos(modulo.children, usuarioPapel);
        } else {
          return modulo;
        }
      }
    });
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.usuarioPapel = this._utils.getUsuarioPapel();
    if (this.modulos) {
      if (this.usuarioPapel !== 'super') {
        this.modulosFiltered = this.filterModulos(this.modulos, this.usuarioPapel);
      } else {
        this.modulosFiltered = this.modulos.filter(modulo => modulo.showMenu);
      }
    }
  }
}
